/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExcelExportConfigDto } from '../models/ExcelExportConfigDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExcelExportConfigControllerService {
    /**
     * @param uuid
     * @returns ExcelExportConfigDto OK
     * @throws ApiError
     */
    public static getByUuid(
        uuid: string,
    ): CancelablePromise<ExcelExportConfigDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/excel-export-configs/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns ExcelExportConfigDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: ExcelExportConfigDto,
    ): CancelablePromise<ExcelExportConfigDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/excel-export-configs/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/excel-export-configs/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns ExcelExportConfigDto OK
     * @throws ApiError
     */
    public static getAllConfigs(): CancelablePromise<Array<ExcelExportConfigDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/excel-export-configs',
        });
    }
    /**
     * @param requestBody
     * @returns ExcelExportConfigDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: ExcelExportConfigDto,
    ): CancelablePromise<ExcelExportConfigDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/excel-export-configs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
